import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-wf-open",
  "use": "icon-wf-open-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-wf-open\">\n<g>\n\t<path d=\"M159.3,11.8c0-4.4,3.6-7.9,7.9-7.9h19.5c4.4,0,7.9,3.6,7.9,7.9v176.4c0,4.4-3.6,7.9-7.9,7.9h-19.5c-4.4,0-7.9-3.6-7.9-7.9\n\t\tC159.3,188.2,159.3,11.8,159.3,11.8z\" />\n\t<path d=\"M131,188.2c0,4.4-2.9,5.8-6.4,3.2L8.1,104.7c-3.5-2.6-3.5-6.9,0-9.5L124.6,8.5c3.5-2.6,6.4-1.2,6.4,3.2V188.2z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol